import portfolio from "../images/Portfolio-img.jpg"
import pro2 from "../images/Loading.jpg"
import Learnit from "../images/Landing-page.png"
import estate from "../images/Estates.png"
import crypto from "../images/crypto.png"

const ProjectCardData = [
    {
        imgsrc: estate,
        title: "Kene's Estates",
        text: "A Real Estate page",
        view: "https://kingsleyokonkwo.github.io/kene-s-estates/",
        source: "https://github.com/kingsleyokonkwo/Learn-It-web"
    },

    {
        imgsrc: crypto,
        title: "A cryptocurrency page",
        text: "Saw the design on twitter and coded it",
        view: "https://kingsleyokonkwo.github.io/Crypto-currency/",
        source: "https://github.com/kingsleyokonkwo/Crypto-currency"
    },

    {
        imgsrc: Learnit,
        title: "Learn It Website",
        text: "I implemented light and dark mode features.",
        view: "https://kingsleyokonkwo.github.io/Learn-It-web/",
        source: "https://github.com/kingsleyokonkwo/Learn-It-web"
    },

    {
        imgsrc: portfolio,
        title: "My React Portfolio Website",
        text: "I created this to easily display my works.",
        view: "https://kingsleyokonkwo.github.io/my-portfolio/",
        source: "https://github.com/kingsleyokonkwo/my-portfolio"
    },

    {
        imgsrc: pro2,
        title: "Loading...",
        text: "Coding is fun, they said.",
        view: "https://kingsleyokonkwo.github.io/my-portfolio/",
        source: "https://github.com/kingsleyokonkwo/kene-s-estates"
    }
]

export default ProjectCardData